import { render } from "./AdminStatCard.vue?vue&type=template&id=52cd2f25"
import script from "./AdminStatCard.vue?vue&type=script&lang=js"
export * from "./AdminStatCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__